import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from '../../shared/modals/modal.component';
import { PeriodPropTypes } from '../../shared/propTypes/period';

import {
  hideDeletingDriverModal,
  deleteCustomETRDriver,
} from './store/actions';

import {
  periodOrCurrentSelector,
} from '../../shared/store/selectors';
import { requiredWhenPresent } from '../../shared/propTypes';


class ConfirmDeletingModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    deleteRow: PropTypes.func.isRequired,
    data: requiredWhenPresent(['isVisible'], PropTypes.shape({
      rowData: PropTypes.shape({
        companyCode: PropTypes.string.isRequired,
        countryTaxType: PropTypes.string.isRequired,
        tagName: PropTypes.string.isRequired,
      }).isRequired,
    })),
    fetchReport: PropTypes.func.isRequired,
    period: PeriodPropTypes,
    isVisible: PropTypes.bool,
  };

  deleteRow = async () => {
    const {
      period,
      hideModal,
      deleteRow,
      data,
      fetchReport,
    } = this.props;
    const { manualEntryId } = data.rowData;
    hideModal();

    await deleteRow({
      periodName: period.name,
      manualEntryId,
    });

    fetchReport();
  };

  render() {
    const { hideModal, isVisible } = this.props;
    return (
      <Modal
        className="confirm-deleting-driver-modal"
        title="Deleting custom driver"
        dismissText="Cancel"
        dismissAction={hideModal}
        submitText="Yes"
        submitAction={this.deleteRow}
        closeAction={hideModal}
        isVisible={isVisible}
      >
        <div>
          Are you sure?
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    period: periodOrCurrentSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    hideModal: hideDeletingDriverModal,
    deleteRow: deleteCustomETRDriver,
  }
)(ConfirmDeletingModal);
